<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLowerhand_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M12.959 6.386c.128-.492.607-.78 1.07-.644.462.135.734.645.606 1.137l-.454 1.742-.7 2.691a7 7 0 0 1-.189.615l-3.513-3.72 1.361-5.232c.129-.492.607-.781 1.07-.645.463.137.734.646.606 1.138l-1.39 5.344.837.246zM9.072 7.458l1.463-5.62C10.663 1.346 10.39.837 9.929.7c-.463-.137-.942.152-1.07.644-.084.321-.75 2.878-1.201 4.616zm-2.518-.724-.155.598.837.247q.001-.002.025-.096l5.417 5.735c-.357.578-.79 1.06-1.275 1.39-1.391.942-3.233.877-5.14.316-1.548-.456-4.737-2.046-4.88-5.486a77 77 0 0 1-.05-2.648c-.002-.463.316-.855.747-.926.47-.076.912.256 1 .752.147.829.355 1.984.422 2.293.085.398.58.396.682.003l.688-2.645.268-1.03zm.397-1.522.839-3.224c.127-.492-.143-1-.606-1.137s-.942.152-1.07.644l-.577 2.22z"
        clip-rule="evenodd"
    />
    <path stroke="currentColor" stroke-linecap="round" d="m3 3 11.333 12" />
</svg>
